interface AckoDriveLogoProps {
  className?: string
  variant?: 'dark' | 'light'
}

export const AckoDriveLogo: React.FC<AckoDriveLogoProps> = ({ className, variant }) => {
  const fillColor = variant === 'dark' ? '#fff' : '#191919'
  return (
    <div className={className}>
      <svg width="100%" height="100%" viewBox="0 0 482 158" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_79_392)">
          <path
            d="M274.307 96.6297C268.601 91.2246 260.844 88.5221 252.686 88.5472H232.643V145.15H252.686C257.04 145.15 261.119 144.424 264.773 142.973C271.954 140.145 277.535 135.041 280.487 127.959C284.866 117.624 282.614 104.287 274.282 96.6297H274.307ZM252.711 136.992H241.301V96.7298C246.806 96.8799 256.59 96.0041 261.52 98.3063C272.029 102.035 276.484 114.997 272.38 124.881C269.252 132.814 261.269 137.143 252.736 136.992H252.711Z"
            fill={fillColor}
          />
          <path
            d="M325.805 121.102C336.69 116.523 338.642 100.633 329.533 93.3015C325.429 89.9233 320.124 88.5721 314.519 88.5721H289.996V145.175H298.629V124.155H312.192L327.881 145.175H338.541L321.601 122.654C323.077 122.279 324.503 121.753 325.83 121.102H325.805ZM298.604 96.7297H314.069C321.025 96.7547 326.58 99.182 326.68 106.239C326.856 113.02 320.099 116.398 313.994 116.223H298.604V96.7297Z"
            fill={fillColor}
          />
          <path d="M353.481 88.5471H344.848V145.15H353.481V88.5471Z" fill={fillColor} />
          <path
            d="M387.888 133.089L369.496 88.5471H359.937L384.285 145.55H391.341L415.664 88.5471H406.355L387.888 133.089Z"
            fill={fillColor}
          />
          <path
            d="M428.701 137.067V120.677H458.203V112.57H428.701V96.6296H461.681V88.5471H420.068V145.15H462.082V137.067H428.701Z"
            fill={fillColor}
          />
          <path
            d="M256.114 13.0015H271.028L294.801 69.2291H278.21L274.131 59.2697H252.611L248.632 69.2291H232.367L256.139 13.0015H256.114ZM269.677 47.2084L263.446 31.3436L257.14 47.2084H269.652H269.677Z"
            fill={fillColor}
          />
          <path
            d="M293.124 41.4781V41.3279C293.124 25.0627 305.636 12.3008 322.552 12.3008C333.962 12.3008 341.294 17.0802 346.249 23.9366L334.613 32.9451C331.435 28.9664 327.756 26.4139 322.401 26.4139C314.594 26.4139 309.089 33.0452 309.089 41.1778V41.3279C309.089 49.7107 314.594 56.2418 322.401 56.2418C328.232 56.2418 331.66 53.5393 335.013 49.4605L346.649 57.7432C341.394 65 334.288 70.355 321.926 70.355C305.986 70.355 293.124 58.1436 293.124 41.4781Z"
            fill={fillColor}
          />
          <path
            d="M351.653 13.4017H367.118V36.0478L386.336 13.4017H404.678L383.533 37.3991L405.379 69.2288H386.786L372.748 48.4844L367.093 54.7904V69.2288H351.628V13.4017H351.653Z"
            fill={fillColor}
          />
          <path
            d="M401.976 41.4781V41.3279C401.976 25.2879 414.888 12.3008 432.129 12.3008C449.37 12.3008 462.107 25.1378 462.107 41.1778V41.3279C462.107 57.3679 449.195 70.355 431.954 70.355C414.713 70.355 401.976 57.518 401.976 41.4781ZM446.317 41.4781V41.3279C446.317 33.2704 440.487 26.2638 431.954 26.2638C423.421 26.2638 417.841 33.1203 417.841 41.1778V41.3279C417.841 49.3854 423.671 56.392 432.104 56.392C440.537 56.392 446.292 49.5356 446.292 41.4781H446.317Z"
            fill={fillColor}
          />
          <path
            d="M203.69 54.8906V102.685C203.69 106.364 202.039 109.517 198.686 111.719C156.847 139.144 125.167 150.655 114.082 153.858C98.7923 158.287 90.6847 157.812 89.3835 157.712C61.4825 155.685 14.4635 117.274 14.4635 117.274C14.4635 117.274 52.8244 126.658 141.457 84.4432C158.073 76.5358 176.615 68.0029 198.185 57.9936C198.185 57.9936 202.89 55.9667 203.69 54.8657V54.8906Z"
            fill="#0D8452"
          />
          <path
            d="M201.463 53.2641C201.713 53.0639 202.014 52.7886 202.164 52.6135C202.364 52.3632 202.539 52.1131 202.639 51.8128C202.915 51.012 202.84 50.0111 202.389 49.2854C201.563 47.9341 200.212 47.0333 198.686 46.0574C156.847 18.6317 125.167 7.12098 114.082 3.91799C98.7923 -0.51115 90.6847 -0.0357269 89.3835 0.0643666C61.4825 2.09126 14.4635 40.5022 14.4635 40.5022C14.4635 40.5022 52.8244 31.1184 141.457 73.3328C144.31 74.6841 147.213 76.0604 150.19 77.4617L198.611 55.0158C198.611 55.0158 201.063 53.6395 201.488 53.2891L201.463 53.2641Z"
            fill="#0DB272"
          />
          <path
            d="M59.3804 78.8379C59.4305 68.6283 60.7067 58.4438 63.0589 48.3594L63.3842 47.1082C45.9178 43.0044 33.0558 42.1285 25.3236 42.1285C18.9426 42.1285 15.5645 42.7041 14.4134 42.9544C12.3365 43.4048 10.8601 45.0563 9.80911 46.4576C3.57829 54.7404 -6.10352e-05 66.5514 -6.10352e-05 78.8379C-6.10352e-05 91.1494 3.57829 102.935 9.80911 111.218C10.8601 112.619 12.3365 114.271 14.4134 114.721C15.5645 114.972 18.9677 115.547 25.3236 115.547C33.0558 115.547 45.9178 114.671 63.3842 110.567L63.0589 109.316C60.7067 99.2319 59.4305 89.0224 59.3804 78.8379Z"
            fill="#63E08D"
          />
        </g>
        <defs>
          <clipPath id="clip0_79_392">
            <rect width="500" height="158" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}
